import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 15px 0;
`

export const Container = styled.section`
  background-color: ${colors.green};
  color: ${colors.white};
  padding: 10px 0;
  margin: 0 20px;
  padding-left: 10px;
`
export const Title = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${colors.white};
  padding-right: 10px;
`
export const Total = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: ${colors.black};
  background-color: ${colors.white};
  width: 30px;
  height: 20px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const Download = styled.div`
  cursor: pointer;
`

export const ContainerNoContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.grayExtraLight};
  font-weight: 400;
  font-size: 14px;
  padding: 30px;
  margin: 0 20px;
  color: ${colors.black};
`

export const NoContent = styled.span`
  padding-left: 10px;
`
